import React, { useEffect, useState, useMemo, useRef } from "react";
import axiosInstance from "../../../utils/axiosInstance";
import { useParams } from "react-router-dom";
import moment from "moment";
import $ from "jquery";
import "datatables.net-bs4/js/dataTables.bootstrap4.js";
import "datatables.net-bs4/css/dataTables.bootstrap4.css";

import "datatables.net-responsive-bs4/js/responsive.bootstrap4.js";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.css";
import PopUpTPResults from "../../agent/components/popup-tp-results";
import PopUpGalaxyResults from "../../agent/components/popup-galaxy-results";

export default function ClientTPDetailsPopup() {
  const { transid } = useParams();
  const [data, setData] = useState(null);
  const [summarydata, setSummaryData] = useState(null);
  const [betSummary, setBetSummary] = useState({});
  const [winAmount, setWinAmount] = useState(0);
  const [winnerName, setWinnerName] = useState(0);

  const [resultsData, setResultsData] = useState(null);
  const [catMid, setCatMid] = useState("");
  const [marketType, setMarketType] = useState("");
  const [Dealer, setDealer] = useState("");
  const [game_type, setGameType] = useState("");

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  useEffect(() => {
    const fetchBetDetails = async () => {
      const response = await axiosInstance.get(
        `profit-loss/trans-details/${transid}`
      );
      let winAmount = response?.data.winAmount;
      let comission = response?.data.comission;
      setWinAmount(winAmount);
      setDealer(response?.data?.bet?.dealer);

      if (comission > 0) {
        let obj = {};
        obj.rnr = "Commission";
        obj.rnrsid = "Commission";
        obj.amnt = 1;
        obj.result_status = "";
        obj.cashout_rate = 1;
        obj.rate = 1;
        obj.pro = comission;
        obj.type = "c";
        obj.lib = 0 - comission;
        obj.stmp = 0 - comission;
        obj.displayTxt = "Commission";
        obj.id = "00000000-0000-0000-0000-000000000000";
        obj.uname = "";
        obj.Dealer = "";

        response.data?.bet?.betList?.push(obj);
      }

      setSummaryData(response.data.bet);

      setBetSummary(response?.data?.bet?.bet_summary[0]);
      console.log(response.data);

      setData(response.data.bet.betList);

      //console.log("FULL RESPONSE", response.data);
      //console.log("BET", response.data.bet);

      setResultsData(response.data.bet.rateJson);

      setWinnerName(response.data.bet?.rateJson?.resultTxt);

      setCatMid(response.data.bet.cat_mid);

      setMarketType(response?.data?.bet?.market_type);
      setGameType(response?.data?.bet?.game_type);
      setDealer(response.data.bet.dealer);
      setIsLoading(false);

      if (marketType === 11) {
        //setPriceValue(betSummary?.rate);
      }
    };
    fetchBetDetails();
  }, []);

  const getType = (data) => {
    if (data == "L" || data == "l") {
      return `<strong>L</strong>`;
    } else if (data == "N" || data == "n") {
      return `<strong>N</strong>`;
    } else if (data == "Y" || data == "y") {
      return `<strong>Y</strong>`;
    } else {
      return `<strong>B</strong>`;
    }
    //return `<strong>${data}</strong>`;
  };

  const [isLoading, setIsLoading] = useState(true);

  const [pageSize, setPageSize] = useState(10);

  const loadingRef = useRef(false);
  const gridTableRef = useRef(null);
  const defaultExpand = false;

  let resultVal = resultsData?.result;

  const toCamelCase = (str) => {
    return str
      .toLowerCase()
      .replace(/[-_\s]+(.)?/g, (_, c) => (c ? c.toUpperCase() : ""));
  };

  const toPascalCase = (str) => {
    const camel = toCamelCase(str);
    return camel.charAt(0).toUpperCase() + camel.slice(1);
  };

  const cols = useMemo(
    () => [
      {
        title: "Runner",
        data: "rnrsid",
        responsivePriority: 1,
        render: (d, type, row, meta) => {
          console.log("Row full data:", row);

          let splitRnr = "";
          let rnrVal = "";
          if (d !== undefined) {
            splitRnr = d.split("-");
            rnrVal = splitRnr[1];
          }

          let runnerName = row.displayTxt;

          if (marketType == 51) {
            //runnerName = "CR2";
          }
          return `
          <div class="d-flex align-items-center justify-content-between"> 
            <span style="white-space: nowrap;font-size: 0.9rem;" class="txt_css">${toPascalCase(
              runnerName
            )}</span>
          </div>`;
        }
      },
      {
        title: "Price",
        data: "rate",
        responsivePriority: 2,
        render: (d, type, row, meta) => {
          if (marketType == 11) {
            return (
              '<span style="white-space: nowrap;font-size: 0.9rem;" class="txt_css">' +
              row?.cashout_rate +
              "</span>"
            );
          } else {
            return d;
          }
        }
        //render: (d) => (d != null ? Number(d)?.toFixed(2) : "")
      },
      {
        title: "Result Status",
        data: "result_status",
        visible: false
      },
      {
        title: "Runner Name",
        data: "rnr",
        visible: false
      },
      {
        title: "Cashout Rate",
        data: "cashout_rate",
        visible: false
      },

      {
        title: "Size",
        data: "amnt",
        responsivePriority: 2,
        render: (d, type, row, meta) => {
          return (
            '<span style="white-space: nowrap;font-size: 0.9rem;" class="txt_css">' +
            formatTruncate(row.amnt) +
            "</span>"
          );
        }
      },
      {
        title: "Side",
        data: "type",
        responsivePriority: 2,
        createdCell: (td, val) => {
          if (val == "c") {
            $(td).css({
              background: "#d03341",
              color: "white",
              textAlign: "left",
              fontWeight: "400",
              fontSize: "0.9rem"
            });
          } else {
            if (val == "B" || val == "b") {
              $(td).css({
                background: "#179aaf",
                color: "white",
                textAlign: "left",
                fontWeight: "400",
                fontSize: "0.9rem"
              });
            } else {
              $(td).css({
                background: "#dc3545",
                color: "white",
                textAlign: "left",
                fontWeight: "400",
                fontSize: "0.9rem"
              });
            }
          }
        },
        render: (d, type, row, meta) => {
          if (row?.type == "b") {
            return `<strong style="font-size: 0.9rem;color:black" class="txt_css">B</strong>`;
          } else if (row?.type == "l") {
            return `<strong style="font-size: 0.9rem;color:black" class="txt_css">L</strong>`;
          } else {
            return `<strong></strong>`;
          }
        }
        //render: (d) => `<strong>${d}</strong>`
      },
      {
        title: "P/L",
        data: "lib",
        responsivePriority: 2,
        render: (d, type, row) => {
          let val = 0;

          if (row.type == "c") {
            val = row.lib;
            return `<span style="white-space: nowrap;font-size: 0.9rem;color:red" class="txt_css">${formatTruncate(
              val
            )}</span>`;
          } else {
            if (marketType == 11) {
              let rate = row?.cashout_rate;
              val = row.amnt * rate;
            } else {
              if (row.result_status) {
                if (row.result_status == 1) {
                  val = row.pro;
                } else {
                  val = row.lib;
                }
              } else {
                val = row.type.toUpperCase() === "L" ? row.lib : row.pro;
              }
            }

            return `<span style="white-space: nowrap;font-size: 0.9rem;" class="txt_css">${formatTruncate(
              val
            )}</span>`;
          }
        }
      },
      {
        title: "Placed At",
        data: "stmp",
        render: (d) =>
          `<span style="white-space: nowrap;font-size: 0.9rem;" class="txt_css">${moment(
            d
          ).format("MM/DD/YYYY HH:mm:ss a")}</span>`
      },
      {
        title: "Settled At",
        data: null,
        render: () => {
          return `<span style="white-space: nowrap;font-size: 0.9rem;" class="txt_css">${moment(
            summarydata?.created_date
          ).format("MM/DD/YYYY HH:mm:ss a")}</span>`;
        }
      },
      {
        title: "Order Id",
        data: "id",
        render: (d) =>
          `<strong style="white-space: nowrap;font-size: 0.9rem;" class="txt_css">${
            d ?? ""
          }</strong>`
      },
      {
        title: "",
        data: "pro",
        visible: false,
        render: (d) => `<span class="txt_css">${d}</span>`,
        responsivePriority: 3
      },
      {
        title: "",
        data: "displayTxt",
        visible: false
      },
      {
        title: "Customer",
        data: "uname",
        visible: true
      },
      {
        title: "Dealer",
        data: null,
        render: () => {
          return Dealer;
        },
        visible: true
      }
      /*{
        title: "FullOdds",
        data: null,
        render: () => {
          return "FullOdds";
        },
        visible: true
      }*/
    ],
    [summarydata]
  );

  useEffect(() => {
    // Don't initialize DataTable while loading or if no data
    if (isLoading || !data.length) return;

    const $table = $(gridTableRef.current);
    if (!$table.length) return;

    // Clean up any existing DataTable properly
    if ($.fn.dataTable.isDataTable($table)) {
      const dt = $table.DataTable();
      // Remove all event listeners first
      $table.off("click", "button.toggle-row");
      dt.off("order.dt search.dt draw.dt");
      dt.off("responsive-resize draw");
      // Destroy the DataTable
      dt.destroy(true);
      $table.empty();
    }

    // Normalize column definitions (support data/title and legacy mData/sTitle)
    const normalizedCols = (cols || []).map((c) => ({
      ...c,
      title: c.title || c.sTitle || "",
      data: c.data || c.mData || c.name || "",
      orderable: typeof c.orderable === "boolean" ? c.orderable : true
    }));

    // Compute initial order from columns (supports col.order = "asc"|"desc")
    const initialOrder = [];
    normalizedCols.forEach((col, idx) => {
      if (
        col.order &&
        ["asc", "desc"].includes(String(col.order).toLowerCase())
      ) {
        initialOrder.push([idx, col.order]);
      }
    });

    // Build safe data (only include referenced keys + seq)
    const keys = normalizedCols.map((c) => c.data).filter(Boolean);
    const safeData = (data || []).map((row, i) => {
      const out = { seq: i + 1 }; // seq is initial placeholder; will be updated after draw
      keys.forEach((k) => {
        if (k in row) out[k] = row[k];
      });
      return out;
    });

    let dt;
    try {
      dt = $table.DataTable({
        data: safeData,
        columns: normalizedCols,
        responsive: {
          details: {
            type: "column",
            target: 0
          }
        },
        pageLength: pageSize || 10,
        lengthChange: false,
        paging: true,
        autoWidth: true,
        ordering: true,
        order: initialOrder,
        columnDefs: [
          {
            className: "dtr-control",
            orderable: false,
            targets: 0
          },
          {
            responsivePriority: 10000,
            targets: "_all"
          }
        ],
        //columnDefs: [{ targets: 0, orderable: false }], // safeguard
        //dom: '<"top d-flex flex-wrap justify-content-between align-items-center" <"dataTables_length"l> <"dt-search"f> <"dt-buttons"> >rt<"bottom d-flex justify-content-between align-items-center"ip><"clear">',
        dom: '<"dt-search"f>' + "rt" + "<'row'<'col-sm-5'i><'col-sm-7'p>>",

        language: {
          paginate: { previous: "&laquo;", next: "&raquo;" }
        },
        orderClasses: false,
        rowCallback: function (row, data, index) {
          // Mobile breakpoint (same as your CSS media query)
          const isMobile = window.matchMedia("(max-width:640px)").matches;

          if (isMobile) {
            // single dark color for every main row on mobile
            $(row).css({
              "background-color": "#f2f2f2", // dark row background
              color: "" // light text
            });
          } else {
            // Desktop: keep zebra striping you had previously
            $(row).css({
              "background-color": index % 2 === 0 ? "" : "#ffffff",
              color: "" // let default text color apply
            });
          }
        }
      });
    } catch (error) {
      console.error("Error initializing DataTable:", error);
      return;
    }

    // Helper: find hidden columns for a row (used for child details)
    const getHiddenColumnsForRow = (tr) => {
      const hiddenCols = [];
      $(tr)
        .find("td")
        .each((i, td) => {
          if ($(td).css("display") === "none" || $(td).is(":hidden"))
            hiddenCols.push(i);
        });
      return hiddenCols;
    };

    //mobile view
    // Build hidden row details (same as your previous implementation)

    const buildHiddenDetails = (rowData, tr) => {
      const settings = dt.settings()[0];
      const hiddenCols = getHiddenColumnsForRow(tr);
      if (!hiddenCols.length || hiddenCols.length === normalizedCols.length)
        return "";
      let html = "";

      hiddenCols.forEach((i) => {
        const col = dt.column(i);

        if (!col || !col.header()) return;

        const title = $(col.header()).text();
        const colDef = normalizedCols[i];
        const rawVal = rowData[colDef.data];

        // Using the same render() as parent column
        const rendered = colDef.render
          ? colDef.render(rawVal, "display", rowData, { row: 0, col: i })
          : rawVal ?? "";

        html += `
      <tr>
        <td style="width:40%;border-top:0;border-left:0;border-right:0;border-bottom:1px solid #eee;">
          <span style="font-weight:bold;">${title}</span> 
          ${rendered}
        </td>
      </tr>`;
      });
      return html;
    };

    // Update toggle button / child rows as before
    const updateToggleButtons = () => {
      if (!$.fn.dataTable.isDataTable($table)) return;
      dt.rows().every(function () {
        const tr = $(this.node());
        const $btn = tr.find("button.toggle-row");
        const hiddenCols = getHiddenColumnsForRow(tr);
        const anyHidden =
          hiddenCols.length > 0 && hiddenCols.length < normalizedCols.length;
        if (anyHidden) {
          $btn.show();
          if (defaultExpand && !this.child.isShown()) {
            const details = buildHiddenDetails(this.data(), tr);
            if (details.trim()) {
              this.child(
                `<table class="table table-sm mb-0">${details}</table>`
              ).show();
              tr.addClass("shown");
              $btn
                .text("−")
                .removeClass("toggle-closed")
                .addClass("toggle-open");
            }
          } else if (this.child.isShown()) {
            const newDetails = buildHiddenDetails(this.data(), tr);
            this.child(
              `<table class="table table-sm mb-0">${newDetails}</table>`
            ).show();
          }
        } else {
          $btn.hide();
          if (this.child && this.child.isShown()) {
            this.child.hide();
            tr.removeClass("shown");
          }
        }
      });
    };

    $table.on("click", "button.toggle-row", function () {
      const tr = $(this).closest("tr");
      const row = dt.row(tr);
      const hiddenCols = getHiddenColumnsForRow(tr);
      if (!hiddenCols.length || hiddenCols.length === normalizedCols.length)
        return;
      if (row.child.isShown()) {
        row.child.hide();
        tr.removeClass("shown");
        $(this).text("+").removeClass("toggle-open").addClass("toggle-closed");
      } else {
        const details = buildHiddenDetails(row.data(), tr);
        if (!details.trim()) return;
        row
          .child(`<table class="table table-sm mb-0">${details}</table>`)
          .show();
        tr.addClass("shown");
        $(this).text("−").removeClass("toggle-closed").addClass("toggle-open");
      }
    });

    // Initial numbering (after initial draw)
    requestAnimationFrame(() => {
      updateToggleButtons();
    });

    const safeRecalc = () => {
      if (!$.fn.dataTable.isDataTable($table)) return;
      clearTimeout(window.__dt_safe_timer);
      window.__dt_safe_timer = setTimeout(() => {
        try {
          dt.responsive.recalc();
          requestAnimationFrame(() => updateToggleButtons());
        } catch (err) {
          console.warn("Resize skip:", err);
        }
      }, 30);
    };

    dt.on("responsive-resize draw", safeRecalc);
    window.addEventListener("resize", safeRecalc);

    return () => {
      window.removeEventListener("resize", safeRecalc);
      clearTimeout(window.__dt_safe_timer);
      $table.off("click", "button.toggle-row");
      if ($.fn.dataTable.isDataTable($table)) {
        try {
          const dtInstance = $table.DataTable();
          if (dtInstance) {
            dtInstance.off("order.dt search.dt draw.dt");
            dtInstance.off("responsive-resize draw");
            dtInstance.destroy(true);
          }
        } catch (error) {
          console.warn("Error during DataTable cleanup:", error);
        }
      }
    };
  }, [cols, data, pageSize, defaultExpand, isLoading]);

  return (
    <>
      <div className="animated fadeIn" style={{ margin: 0 }}>
        <div className="container-fluid p-0">
          {/* small style overrides are added below using a standard <style> element */}
          <div className="row w-100 m-0">
            <div className="col-12 p-0">
              <div className="card">
                <div className="card-header">
                  <h5 className="m-0 d-flex align-items-center">
                    <span className="heading_css">{summarydata?.remark}</span>
                  </h5>
                </div>

                <div className="card-body site_family">
                  <div class="row mb-3">
                    <div
                      class="col-4 col-md-4 txt_css"
                      style={{ fontSize: "1rem" }}
                    >
                      Winner
                      <span class="badge badge-warning ml-2">
                        {/* chicken road  */}
                        {marketType == 60
                          ? resultsData?.mid_stat === "cashout"
                            ? "CASHOUT"
                            : resultsData?.mid_stat === "crash"
                            ? "CRASH"
                            : ""
                          : winnerName}
                      </span>
                      {/*<span class="badge badge-warning ml-2">{winnerName}</span>*/}
                    </div>

                    <div
                      class="col-4 col-md-4 txt_css"
                      style={{ fontSize: "1rem" }}
                    >
                      Net PL
                      <span
                        id="win_amt"
                        className={
                          winAmount < 0
                            ? "badge badge-danger bg-danger ml-2"
                            : "badge badge-success bg-success ml-2"
                        }
                        style={{
                          fontSize: "100%",
                          color: "white",
                          padding: 4,
                          borderRadius: 4,
                          fontSize: "0.8rem"
                        }}
                      >
                        {formatTruncate(winAmount)}
                      </span>
                    </div>
                    <div
                      class="col-4 col-md-4 txt_css"
                      style={{ fontSize: "1rem" }}
                    >
                      Username
                      <span class="ml-2 badge badge-warning">
                        {" "}
                        {summarydata?.uname}
                      </span>
                    </div>
                  </div>

                  <div className="datatable-wrapper">
                    <table
                      ref={gridTableRef}
                      className="table table-striped table-bordered dataTable no-footer dtr-inline display mt-2 txt_css"
                      style={{ width: "100%" }}
                    >
                      <thead>
                        <tr>
                          {cols.map((c) => (
                            <th key={String(c.data || c.title)}>{c.title}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody />
                    </table>
                  </div>
                </div>
                {game_type == 7 ? (
                  <PopUpTPResults
                    resultsData={resultsData}
                    catMid={catMid}
                    marketType={marketType}
                  />
                ) : game_type == 10 ? (
                  <PopUpGalaxyResults
                    resultsData={resultsData}
                    catMid={catMid}
                    marketType={marketType}
                  />
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* SAFE CSS (no dangerouslySetInnerHTML) */}
      <style>{`

table.dataTable.no-footer {
  border-bottom: 0px solid #111;
}
.table.dataTable thead th, table.dataTable thead td{
  border-bottom: 1px solid #dee2e6;
}
.dt-paging-button { 
  padding: .5em 0px; 
}

        .table { width: 100% !important; }
        .table.table-striped td, .table.table-striped th {
          padding: 4px 8px !important;
          font-size: 16px;
          white-space: normal !important;
          vertical-align: middle;
        }
        
        .pagination {
          
          float: right;
      }
        .toggle-row {
          border: none;
          cursor: pointer;
          width: 15px;
          height: 15px;
          border-radius: 50%;
          font-weight: 700;
          font-size: 14px;
          color: #fff;
          background:#337ab7;
          display:flex;
          align-items:center;
          justify-content:center;
          font-family: 'Courier New', Courier, monospace;
          border: 2px solid white;
          box-shadow: 0 0 3px #444;
           
        }
        .toggle-open { background:#dc3545 !important; }
        .summary-table th { text-align:left; border: 0; padding: 0.25rem 0; }
        @media (max-width: 640px) {
          .pagination {
          
            float: unset;
        }
        .dt-info {
          float: unset;
          
      }
          .summary-table th { display:block; width:100%; white-space:normal; font-size:14px; }
          .table.table-striped td, .table.table-striped th { font-size:14px !important; padding:6px 6px !important; }
        }
        .heading_css {
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
          margin-bottom: .5rem;
          line-height: 1.2;
          font-size: 1.5rem;
          font-weight: 500;
          padding: .75rem 1.25rem;
         
        }

        .txt_css {
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
        }



        table.dataTable.dtr-inline.collapsed tbody tr td.dtr-control:before,
        table.dataTable.dtr-inline.collapsed tbody tr th.dtr-control:before 
        {
          height: 14px;
    width: 14px;
    margin-right: .5em;
    display: inline-block;
    content: "+";
    color: white;
    border: 2px solid white;
    border-radius: 14px;
    box-shadow: 0 0 3px #444;
    box-sizing: content-box;
    text-align: center;
    text-indent: 0 !important;
    font-family: 'Courier New', Courier, monospace;
    line-height: 14px;
    background-color: #337ab7;
    float: inline-start;
           
        }

        div.dt-container .dt-paging .dt-paging-button {
          padding: 4px 0px;
        }

        div.dt-container .dt-paging .dt-paging-button:hover {
          /* color: white !important; */
          border: 0px solid #111;
          background-color: transparent
          background: unset;
      }

/* Open row */
table.dataTable.dtr-inline.collapsed > tbody > tr.dtr-expanded > td.dtr-control:before, table.dataTable.dtr-inline.collapsed > tbody > tr.dtr-expanded > th.dtr-control:before {
  content: '-';
  background-color: #d33333;
  border: 2px solid white;
  float: inline-start;
}
      `}</style>
    </>
  );
}
